<template>
  <v-container id="users-tables" fluid tag="section">
    <base-material-card
      icon="mdi-clipboard-text"
      title="Yêu cầu hoàn tiền"
      class="px-5 py-3"
    >
      <v-data-table
        :headers="headers"
        :items="requests"
        :page.sync="page"
        :loading="loading"
        single-expand
        :expanded.sync="expanded"
        show-expand
        loading-text="Đang tải... Vui lòng chờ"
        hide-default-footer
      >
        <template v-slot:[`item.user.avatar`]="{ item }">
          <v-avatar size="36" class="elevation-2">
            <img
              alt="Avatar"
              :src="
                getLodash(item, 'user.avatar', null) ||
                  require('@/assets/face.jpg')
              "
            />
          </v-avatar>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div :class="item.status ? 'green--text' : 'grey--text'">
            {{ item.status ? "Đã hoàn tiền" : "Chưa hoàn tiền" }}
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            x-small
            class="primary"
            :loading="loadingUpdate && editId === item._id"
            :disabled="item.status"
            @click="confirmRefund(item)"
          >
            Hoàn tiền
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ item }">
          <td :colspan="headers.length" class="pa-5">
            <div class="text-h4">
              Chi tiết ca tham vấn
            </div>
            <v-row>
              <v-col cols="3">
                <div class="text-subtitle-1">
                  Tham vấn viên/Người lắng nghe:
                </div>
              </v-col>
              <v-col cols="9">
                <div>{{ getLodash(item, "bookingSlot.user.name", "N/A") }}</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <div class="text-subtitle-1">
                  Thời gian:
                </div>
              </v-col>
              <v-col cols="9">
                <div>
                  {{ (getLodash(item, "bookingSlot.startTime"), "N/A") }}
                </div>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        class="mt-5"
        :circle="false"
        :disabled="false"
        :length="totalPages"
        next-icon="navigate_next"
        prev-icon="navigate_before"
        :page="page"
        :total-visible="totalPages"
        @input="goToPage"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import RefundRequestApi from "@/api/RefundRequestApi";
import get from "lodash.get";

export default {
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "user.avatar"
        },
        { text: "Người dùng", value: "user.name" },
        { text: "Số tiền", value: "bookingSlot.price" },
        {
          text: "Mã giao dịch Ngân Lượng",
          value: "bookingSlot.transactionCode"
        },
        { text: "Thời gian", value: "createdAt" },
        { text: "Trạng thái", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "", value: "data-table-expand" }
      ],
      page: 1,
      totalPages: 0,
      requests: [],
      expanded: [],
      editId: "",
      loading: false,
      loadingUpdate: false
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const response = await RefundRequestApi.getAll();
      this.loading = false;
      const { ok, data, headers } = response;
      if (ok) {
        this.requests = data;
        this.totalPages = parseInt(headers["x-total"], 10);
      }
    },

    formatDate(date) {
      return new Date(date).toLocaleString("vi");
    },

    async goToPage(page) {
      this.page = page;
      this.loading = true;
      const response = await RefundRequestApi.getAll(page);
      this.loading = false;
      const { ok, data } = response;
      if (ok) {
        this.requests = data;
      }
    },

    async confirmRefund(item) {
      const agree = confirm("Bạn có xác nhận đã hoàn tiền cho người dùng?");
      if (agree) {
        this.editId = item._id;
        this.loadingUpdate = true;
        const response = await RefundRequestApi.update(item._id, {
          status: true
        });
        const { ok, data } = response;
        this.editId = "";
        this.loadingUpdate = false;
        if (ok) {
          Object.assign(this.requests[this.requests.indexOf(item)], {
            status: data.status
          });
        } else {
          alert("Cập nhật không thành công!");
        }
      }
    },

    getLodash(item, path, defaultValue) {
      return get(item, path, defaultValue);
    }
  }
};
</script>
